export function clientInitials(name:string=''){
 const words=name.replace(/\b(?:e\.?\s*v\.?|s\.?l\.?|s\.?a\.?)$/i,'').match(/[\p{L}]+(?:[-’'][\p{L}]+)*/gu)||[];
 return words.filter(w=>!['de','del','la','las','los','y'].includes(w.toLowerCase())).slice(0,3).map(w=>Array.from(w)[0]).join('').toUpperCase();
}
